module.exports = __webpack_public_path__ + "93b6198bb36b5dd25ab035248c9ffa50.pdf";